(() => {
  const PRODUCT_MAP = {
    'talent-patrol-skip-the-line': { key: 'talent_skip', show: 'talent_patrol', needsSubmission: true },
    'talent-patrol-featured-performer': { key: 'talent_featured', show: 'talent_patrol', needsSubmission: true },
    'talent-patrol-headliner': { key: 'talent_headliner', show: 'talent_patrol', needsSubmission: true },
    'late-nite-date-night-priority-question': { key: 'late_priority_question', show: 'date_night' },
    'late-nite-date-night-priority-call-in': { key: 'late_priority_callin', show: 'date_night' },
    'late-nite-date-night-rate-my-fit': { key: 'late_rate_fit', show: 'date_night' },
    'late-nite-date-night-dating-profile-review': { key: 'late_profile_review', show: 'date_night' },
    'late-nite-date-night-date-night-breakdown': { key: 'late_breakdown', show: 'date_night' }
  };

  const currentHandle = () => {
    const match = location.pathname.match(/^\/products\/([^/?#]+)/i);
    return match ? decodeURIComponent(match[1]) : '';
  };

  const validUuid = value => /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(String(value || ''));

  const addHidden = (form, name, value) => {
    let input = form.querySelector(`input[name="${name.replace(/"/g,'\\"')}"]`);
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    const next = value == null ? '' : String(value);
    if (input.value !== next) input.value = next;
  };

  const ensureNotice = (form, html, state='info') => {
    let box = form.querySelector('[data-lrnd-commerce-notice]');
    if (!box) {
      box = document.createElement('div');
      box.dataset.lrndCommerceNotice = '';
      box.style.cssText = 'margin:14px 0;padding:14px 16px;border:1px solid rgba(18,152,255,.45);border-radius:12px;background:#061019;color:#f5f8fb;font:600 14px/1.45 Arial,sans-serif;';
      const submit = form.querySelector('[type="submit"]');
      if (submit) form.insertBefore(box, submit); else form.appendChild(box);
    }
    if (box.dataset.state !== state) box.dataset.state = state;
    if (box.innerHTML !== html) box.innerHTML = html;
    return box;
  };

  const configureProductPage = () => {
    const handle = currentHandle();
    const config = PRODUCT_MAP[handle];
    if (!config) return;

    const params = new URLSearchParams(location.search);
    let submissionId = params.get('submission') || '';
    if (!validUuid(submissionId)) {
      try { submissionId = localStorage.getItem('lrndTalentSubmissionId') || ''; } catch (_) {}
    }
    if (!validUuid(submissionId)) submissionId = '';

    let passToken = '';
    try {
      const pending = JSON.parse(localStorage.getItem('lrndTalentCheckoutPending') || 'null');
      passToken = String(pending?.passToken || localStorage.getItem('lrndTalentArtistPassToken') || '');
    } catch (_) {
      try { passToken = localStorage.getItem('lrndTalentArtistPassToken') || ''; } catch (_) {}
    }
    const returnPath = passToken ? `/pages/talent-patrol?artist_pass=${encodeURIComponent(passToken)}` : '/pages/talent-patrol';

    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      const signature = `${handle}:${submissionId || 'none'}`;
      if (form.dataset.lrndCommerceConfigured === signature) return;

      addHidden(form, 'properties[_lrnd_product_key]', config.key);
      addHidden(form, 'properties[_lrnd_show]', config.show);
      addHidden(form, 'properties[_lrnd_source]', 'lindsey_live');

      if (config.needsSubmission) {
        addHidden(form, 'properties[_talent_submission_id]', submissionId);
        addHidden(form, 'properties[_artist_pass_token]', passToken);
        addHidden(form, 'properties[_lrnd_return_path]', returnPath);
        const submitButtons = [...form.querySelectorAll('[type="submit"],button[name="add"]')];
        if (!submissionId) {
          submitButtons.forEach(button => {
            button.disabled = true;
            button.setAttribute('aria-disabled','true');
          });
          ensureNotice(form,
            '<strong style="display:block;margin-bottom:6px;color:#57c7ff">SUBMIT YOUR SONG FIRST</strong>' +
            'Talent Patrol upgrades must be attached to a music submission. ' +
            '<a href="/pages/talent-patrol#submit-music" style="color:#fff;text-decoration:underline">Submit your song</a>, then choose your upgrade.',
            'needs-submission'
          );
        } else {
          submitButtons.forEach(button => {
            button.disabled = false;
            button.removeAttribute('aria-disabled');
          });
          ensureNotice(form,
            '<strong style="display:block;margin-bottom:6px;color:#57c7ff">CONNECTED TO YOUR TALENT PATROL SUBMISSION ✓</strong>' +
            'Your checkout will be locked to this exact song before payment, then the Artist Pass updates automatically after Shopify confirms payment.',
            'connected'
          );
        }
      } else {
        ensureNotice(form,
          '<strong style="display:block;margin-bottom:6px;color:#57c7ff">LINDSEY RENEE LIVE</strong>' +
          'After payment, you’ll return to your private Date Night Pass. Paid live experiences stay out of the Guest Lobby until Lindsey personally invites you.',
          'late-nite'
        );
      }

      form.dataset.lrndCommerceConfigured = signature;
    });
  };

  const start = () => {
    configureProductPage();

    // Shopify's theme editor can re-render a section. Reconfigure only for that
    // explicit event instead of observing every DOM mutation on the page.
    document.addEventListener('shopify:section:load', configureProductPage);
    window.addEventListener('pageshow', configureProductPage);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
